<div class="modal-header border-top-5-light-red">

  <h5 class="modal-title">{{'BlockedSlot.CancelBlockedSlotTitle' | translate}} </h5>
</div>
<div class="modal-body bay-club-light-blue-2-bg">
  <div translate>
    BlockedSlot.CancelBlockedSlotConfirm
  </div>
  <bcu-local-spinner [size]="40" [visible]="(isLoading$ | async).visible" *ngIf="(isLoading$ | async).visible">
  </bcu-local-spinner>

  <form [formGroup]="form" novalidate *ngIf="form" ngxsForm="cbCourtEventModals.cancelBlockedSlotForm">

    <div class="cancel-blocked-slot-mode mt-2" *ngIf="input.isRecurring">
      <input id="just-this" type="radio" class="action-mode-input" [value]="cancelMode.thisEvent" formControlName="cancelMode">
      <label class="ml-1 action-mode-label" for="just-this" translate>BlockedSlot.CancelBlockedSlotThisEvent</label>
    </div>

    <div class="cancel-blocked-slot-mode mt-1" *ngIf="input.isRecurring">
      <input id="this-and-following" type="radio" class="action-mode-input" [value]="cancelMode.thisAndFollowing"
        formControlName="cancelMode">
      <label class="ml-1 action-mode-label" for="this-and-following"
        translate>BlockedSlot.CancelBlockedSlotThisAndFollowing</label>
    </div>

    <div>
      <label class="mb-1 dark-grey">{{'BlockedSlot.Reason' | translate}}</label>
      <div>
        <textarea class="w-100 form-control" formControlName="reason"></textarea>
      </div>
    </div>
  </form>

</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button type="button" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()"
      class="btn btn-light-blue-outline btn-sm">{{'General.Dismiss' | translate}}</button>

    <button type="button" (click)="onSave()" [disabled]="!(isFormValid$ | async)"
      class="btn btn-light-blue btn-sm ml-2">{{'General.Confirm' | translate}}</button>
  </div>
</div>
